export { TagSize, TagType } from './tag.component';
